import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

export const navigateAndReload = (uri: string[], router: Router, translateService: TranslateService) => {
  router
    .navigateByUrl('/', { skipLocationChange: true })
    .then(() => router.navigate(Object.values(translateService.instant(uri))));
};
